import React from 'react';
import classNames from 'classnames';

import { isUserLoggedIn } from 'redux/modules/sessions/selectors';
import { useWtrSelector } from 'redux/hooks';
import urls from 'constants/urls';
import { IconProps } from '@johnlewispartnership/wtr-ingredients/foundations/icons/svg-icon';
import { User } from '@johnlewispartnership/wtr-ingredients/foundations/icons';
import { LoginLink } from 'components/AuthenticationAction/LoginLink';
import { TextLink } from '@johnlewispartnership/wtr-ingredients/ingredients/TextLink';

import styles from './SignIn.scss';

type Props = {
  className?: string;
  iconSize?: IconProps['size'];
  iconClassName?: string;
  newHeader?: boolean;
  textClassName?: string;
  withRegister?: boolean;
  testId?: string;
};

const SignIn = ({
  className = '',
  iconSize,
  iconClassName = '',
  newHeader = false,
  textClassName = '',
  withRegister = true,
  testId = 'loginAnchor',
}: Props) => {
  const loggedIn = useWtrSelector(isUserLoggedIn);
  const signInText = newHeader ? 'Sign in/Register' : 'Sign in';

  return loggedIn ? null : (
    <>
      <LoginLink className={className} data-test={testId} underline="hover">
        <User className={classNames(styles.signInIcon, iconClassName)} size={iconSize} />
        <span className={textClassName}>{signInText}</span>
      </LoginLink>
      {withRegister ? (
        <TextLink
          className={className}
          data-test="registerAnchor"
          href={urls.tokenClientRegistration}
          underline="hover"
        >
          Register
        </TextLink>
      ) : null}
    </>
  );
};

SignIn.displayName = 'SignIn';

export default SignIn;
